<div class="tab-container">
  @if (filteredTabs().length > 0) {
    <div class="tabs-wrapper">
      <div class="tabs-header-wrapper">
        <div class="tabs-header" #tabsHeader>
          <lib-tabs
            [tabs]="filteredTabs()"
            [activeId]="getIdAsString(activeId())"
            [showClose]="showClose()"
            (onClose)="onClose($event)"
            (tabChange)="onTabChange($event)"
          ></lib-tabs>
        </div>

        <div class="tabs-menu">
          <button
            #tabsMenuBtn
            class="nav-btn tabs-menu-btn"
            (click)="toggleVaultTabsMenu()"
            [class.active]="vaultTabsMenuOpen()"
            title="Opciones de pestañas"
            type="button"
            aria-label="Menú de pestañas"
            [attr.aria-expanded]="vaultTabsMenuOpen()"
          >
            <lucide-icon name="chevron-down"></lucide-icon>
          </button>

          @if (vaultTabsMenuOpen()) {
            <button
              class="tabs-menu-backdrop"
              type="button"
              aria-label="Cerrar menú"
              (click)="closeVaultTabsMenu()"
            ></button>
            <div
              class="tabs-menu-panel"
              role="menu"
              [style.top.px]="vaultTabsMenuTop()"
              [style.right.px]="vaultTabsMenuRight()"
            >
              <div class="tabs-menu-section-title">
                Pestañas abiertas ({{ vaultClosableTabs().length }}/{{ vaultMaxOpenTabs }})
              </div>

              <div class="tabs-menu-list">
                @for (tab of vaultClosableTabs(); track tab.id) {
                  <div
                    class="tabs-menu-item"
                    role="button"
                    tabindex="0"
                    [class.active]="getIdAsString(activeId()) === getIdAsString(tab.id)"
                    (click)="selectVaultTabFromMenu(tab)"
                    (keydown.enter)="selectVaultTabFromMenu(tab)"
                    (keydown.space)="selectVaultTabFromMenu(tab)"
                  >
                    <span class="tabs-menu-item-label">{{ tab.title }}</span>
                    <button
                      class="tabs-menu-item-close"
                      (click)="closeVaultTabFromMenu(tab, $event)"
                      title="Cerrar"
                      type="button"
                      aria-label="Cerrar pestaña"
                    >
                      ×
                    </button>
                  </div>
                } @empty {
                  <div class="tabs-menu-empty">No hay pestañas abiertas</div>
                }
              </div>

              <div class="tabs-menu-divider"></div>

              <button
                class="tabs-menu-action"
                type="button"
                [disabled]="!hasVaultOtherTabs()"
                (click)="closeVaultOtherTabs()"
              >
                Cerrar las demás
              </button>
              <button
                class="tabs-menu-action"
                type="button"
                [disabled]="!hasVaultTabsToLeft()"
                (click)="closeVaultTabsToLeft()"
              >
                Cerrar a la izquierda
              </button>
              <button
                class="tabs-menu-action"
                type="button"
                [disabled]="!hasVaultTabsToRight()"
                (click)="closeVaultTabsToRight()"
              >
                Cerrar a la derecha
              </button>
              <button
                class="tabs-menu-action danger"
                type="button"
                [disabled]="vaultClosableTabs().length === 0"
                (click)="closeAllVaultTabs()"
              >
                Cerrar todas
              </button>
            </div>
          }
        </div>
      </div>
    </div>
    <div
      class="tab-content-area"
      [style.min-height]="contentMinHeight()"
    >
      <router-outlet></router-outlet>
    </div>
  } @else {
    <div class="empty-state" [style.padding]="emptyPadding()">
      <p class="empty-hint">{{ emptyMessage() }}</p>
    </div>
  }
</div>
